export default {
  data() {
    return {
      plotInfo: JSON.parse(localStorage.getItem('plotInfo')) //获取数据存储对象，例如数据库中的数据对象或者是
    };
  }
};